import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AriOSMarketing } from './pages/AriOSMarketing';
import { Conditions } from './pages/Conditions';
export function AppRouter() {
  return <BrowserRouter data-id="element-27">
      <Routes data-id="element-28">
        <Route path="/" element={<AriOSMarketing data-id="element-30" />} data-id="element-29" />
        <Route path="/conditions" element={<Conditions data-id="element-32" />} data-id="element-31" />
      </Routes>
    </BrowserRouter>;
}